import { render, staticRenderFns } from "./BaseVerifyButton.vue?vue&type=template&id=0127fb35"
import script from "./BaseVerifyButton.vue?vue&type=script&lang=js"
export * from "./BaseVerifyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports